/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PropertyOut {
  id: string;
  key: string;
  name: string;
  type: string;
  calendar_mapping: string | null;
  position: number;
  archived_at: string | null;
}
